import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const FilterAppliedTooltip = ({ targetRef, isVisible, selectedFilters }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (targetRef.current && isVisible) {
      const rect = targetRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8, // ↓ below the button
        left: rect.left + rect.width / 2 + window.scrollX, // center align
      });
    }
  }, [isVisible, targetRef]);

  if (!isVisible) return null;

  return createPortal(
    <div
      className="absolute z-[99999] min-w-[140px] rounded-md bg-white shadow-lg border border-gray-200 px-4 py-3 text-sm text-gray-700"
      style={{
        position: "absolute",
        top: `${position.top}px`,
        left: `${position.left}px`,
        transform: "translateX(-50%)", // center align to button
      }}
    >
      <div className="font-semibold mb-1">Filters Applied</div>
      <ul className="list-disc pl-5 space-y-1">
        {selectedFilters.normalDocument && <li>All Documents</li>}
        {selectedFilters.folder && <li>Folders</li>}
        {selectedFilters.contract && <li>Contracts</li>}
        {selectedFilters.invoice && <li>Invoices</li>}
        {selectedFilters.spreadsheet && <li>Spreadsheets</li>}
      </ul>
    </div>,
    document.body
  );
};

export default FilterAppliedTooltip;
